import { render, staticRenderFns } from "./module1.vue?vue&type=template&id=90ada252&scoped=true"
import script from "./module1.vue?vue&type=script&lang=js"
export * from "./module1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ada252",
  null
  
)

export default component.exports